var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-guidelines",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconography",
    transform: "translate(-1156.000000, -477.000000)",
    fill: "#212121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Success-(snackbar,-modal)-",
    transform: "translate(1156.000000, 477.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_checkmark_225671-(1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M14.5385253,29.0767657 C6.52195794,29.0767657 0,22.5548077 0,14.5385253 C0,6.52195797 6.52195794,0 14.5385253,0 C22.5548077,0 29.0764806,6.52195797 29.0764806,14.5385253 C29.0764806,22.5548077 22.5548077,29.0767657 14.5385253,29.0767657 L14.5385253,29.0767657 Z M14.5385253,1.99537769 C7.62210904,1.99537769 1.99509267,7.62239406 1.99509267,14.5385253 C1.99509267,21.4549416 7.62210904,27.081673 14.5385253,27.081673 C21.4546566,27.081673 27.081388,21.4549416 27.081388,14.5385253 C27.081388,7.62239406 21.4546566,1.99537769 14.5385253,1.99537769 L14.5385253,1.99537769 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path2",
    d: "M11.8462282,21.6221184 C11.5154087,21.6221184 11.1984772,21.4907165 10.9648738,21.2571131 L6.36509437,16.6573336 C5.87830188,16.1708973 5.87830188,15.3814174 6.36509437,14.8949811 C6.85188686,14.4078325 7.64065446,14.4078325 8.12744695,14.8949811 L11.8462282,18.61305 L20.4941838,9.96509437 C20.9802641,9.47830188 21.7697439,9.47830188 22.2565364,9.96509437 C22.7433289,10.4515307 22.7433289,11.2410106 22.2565364,11.727447 L12.7272264,21.2571131 C12.493623,21.4907165 12.1766915,21.6221184 11.8462282,21.6221184",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.58923d822af8f4c3910d1a5b67c4fa8a.svg";
export { ForwardRef as ReactComponent };